module.exports = __webpack_public_path__ + "img/laboratorio_3-4_768.6139666d.jpg";